import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DrugCategoryPage } from './drug-category';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    DrugCategoryPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(DrugCategoryPage),
  ],
})
export class DrugCategoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/drug-category/drug-category.module.ts